import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState, store } from "../../redux-stores/store";
import { fetchInfluencer, updateInfluencer } from "../../redux-stores/slices/influencerSlice";
import { toast } from "react-toastify";
import { getErrorMessage, parseFormFieldError } from "../../utils/helpers";
import { toggleLocationUpdateModal, toggleProfileUpdateModal } from "../../redux-stores/slices/layoutSlice";
import LocationSelection from "../inputs/LocationSelection";
import { Coordinates } from "../../types/address";
import { updateInfluencerLocation } from "../../services/api/influencer";

const UpdateLocation: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    // Fetch existing profile data from Redux
    const { loading, influencer, error: APIError } = useSelector((state: RootState) => state.influencer);
    const [locationListOpen, setLocationListOpen] = useState(false);
    const [saving, setSaving] = useState(false);

    // Local state for form inputs
    const [formData, setFormData] = useState({
        // name: influencer?.name || "",
        // niches: influencer?.niches || [],
        // gender: influencer?.gender || "M",
        // dob: influencer?.dob || "",
        location: influencer?.location || ""
    });

    const [coordinates, setCoordinates] = useState<Coordinates | null>(null);

    useEffect(() => {
        if(!coordinates && influencer && influencer.lat && influencer.lng){
            setCoordinates({latitude: influencer.lat, longitude: influencer.lng});
        }
    }, [coordinates, influencer])

    const [errors, setErrors] = useState<{ [key: string]: string }>({
        name: "",
    });

    // Handle form input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Validate inputs
    const validateForm = () => {
        let isValid = true;
        let validationErrors: { [key: string]: string } = {};

        if (!formData.location) {
            validationErrors.location = "Please select your location."
            isValid = false;
        }

        setErrors(validationErrors);
        return isValid;
    };

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateForm() || !influencer) return;

        // Dispatch the updated profile to Redux
        try {
            setSaving(true);
            await updateInfluencerLocation({ ...formData, ...(coordinates ? {lat: coordinates.latitude, lng: coordinates.longitude} : {})});
            dispatch(toggleLocationUpdateModal(false))
            const token = store.getState().auth.token ?? '';
            await dispatch(fetchInfluencer(token));

        } catch (error) {
            console.error("Error updating location:", error);
            toast.error("Failed to update location. Please try again.");
        } finally {
            setSaving(false);
        }
    };


    useEffect(() => {

        if (!APIError) return;
        if (APIError && typeof APIError === 'object' && APIError.erorrs) {
            setErrors(parseFormFieldError(APIError.erorrs));
            return;
        }

        toast.error(getErrorMessage(APIError));

    }, [APIError])

    return (
        <form onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-075">
                <h4 className="new-slide-up-modal-heading mt-2 mb-0">Update Your Location</h4>
            </div>
            <div className="mt-4 profile-inputs" style={{height: locationListOpen ? '45vh' : 'auto'}}>
                {/* Name Input */}
                {/* <div className="profile-input">
                    <label className="font-12 d-block profile-input-label">
                        Name <span className="text-danger">*</span>
                    </label>
                    <div className={`input-style has-borders has-icon validate-field mb-0 ${errors.name ? "invalid" : ""}`} style={{ marginBottom: '0px !important' }}>
                        <i className="fa fa-user"></i>
                        <input
                            type="text"
                            className="form-control profile-input-form-control"
                            id="name"
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        <label htmlFor="name" className="color-highlight">
                            Name
                        </label>
                    </div>
                    {errors.name && (
                        <small className="text-danger mt-n2 ms-2" >
                            <i className="fa fa-times color-red-dark"></i> {errors.name}
                        </small>
                    )}
                </div> */}


                {/* Date of Birth Input */}
                {/* <div className="profile-input">
                    <label className="font-12 d-block profile-input-label">
                        Date Of Birth <span className="text-danger">*</span>
                    </label>
                    <div className="input-style has-borders has-icon mb-0">
                        <i className="fa fa-calendar"></i>
                        <input
                            type="date"
                            className="form-control date-picker profile-input-form-control"
                            id="dob"
                            name="dob"
                            placeholder="Date of Birth"
                            value={formData.dob}
                            onChange={handleChange}
                        />
                        <label htmlFor="dob" className="color-highlight">
                            Date of Birth
                        </label>
                    </div>
                    {errors.dob && (
                        <small className="text-danger mt-n2 ms-2" >
                            <i className="fa fa-times color-red-dark"></i> {errors.dob}
                        </small>
                    )}
                </div>
                <div className="fv-row ">
                    <GenderSelection gender={formData.gender as Gender} onChange={(gender: Gender) => setFormData({ ...formData, gender })} />
                </div> */}

                {/* <div className="">
                    <NichesSelection niches={formData.niches} onChange={(niches: number[]) => setFormData({ ...formData, niches })} />
                    {errors.niches && (
                        <small className="text-danger mt-n2 ms-2" >
                            <i className="fa fa-times color-red-dark"></i> {errors.niches}
                        </small>
                    )}
                </div> */}

                <div className="mb-2">
                    <LocationSelection value={formData.location} onChange={(city: string) => setFormData({ ...formData, location: city })} onMenuClose={() => {
                        setLocationListOpen(false);
                    }} onMenuOpen={() => setLocationListOpen(true)} updateCoordinates={(coordinates) => setCoordinates(coordinates)} />
                    {errors.location && (
                        <small className="text-danger mt-n2 ms-2" >
                            <i className="fa fa-times color-red-dark"></i> {errors.location}
                        </small>
                    )}
                </div>

            </div>
            {/* Save Changes Button */}
            <div className="campaign-apply-ig-connect-benefit-actions pb-5">
                <button disabled={saving} type="submit" className="btn btn-primary w-100 rounded-4">{saving ? 'Saving...' : 'Save'}</button>
            </div>
        </form >
    );
};

export default UpdateLocation;